import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "box-content" }
const _hoisted_3 = { class: "main" }
const _hoisted_4 = {
  key: 0,
  class: "dots-top",
  src: "/kandidaten/img/dot-pattern-top.svg"
}
const _hoisted_5 = {
  key: 1,
  class: "dots-bottom",
  src: "/kandidaten/img/dot-pattern-bottom.svg"
}
const _hoisted_6 = {
  key: 2,
  class: "progress-wrapper"
}
const _hoisted_7 = {
  key: 3,
  class: "content"
}
const _hoisted_8 = { class: "intro" }
const _hoisted_9 = { class: "reg-form" }
const _hoisted_10 = { class: "p-float-label" }
const _hoisted_11 = { for: "username" }
const _hoisted_12 = {
  key: 0,
  id: "no-email",
  class: "p-error"
}
const _hoisted_13 = {
  key: 1,
  id: "no-email",
  class: "p-error"
}
const _hoisted_14 = { class: "p-float-label" }
const _hoisted_15 = {
  class: "p-pl-2 p-ml-2 p-mt-0",
  style: {"line-height":"1.5"}
}
const _hoisted_16 = { for: "password" }
const _hoisted_17 = {
  key: 0,
  class: "p-error"
}
const _hoisted_18 = {
  key: 1,
  id: "password-weak",
  class: "p-error"
}
const _hoisted_19 = { class: "p-float-label" }
const _hoisted_20 = { for: "password2" }
const _hoisted_21 = {
  key: 0,
  class: "p-error"
}
const _hoisted_22 = {
  key: 1,
  id: "password-missmatch",
  class: "p-error"
}
const _hoisted_23 = { class: "p-float-label terms-and-conditions p-mb-4" }
const _hoisted_24 = {
  class: "pointerevents no-tooltip",
  for: "termsandconditions"
}
const _hoisted_25 = {
  href: "/datenschutz",
  target: "_blank"
}
const _hoisted_26 = {
  key: 0,
  class: "p-error"
}
const _hoisted_27 = {
  key: 0,
  class: "p-error"
}
const _hoisted_28 = { class: "mobile-bottom-nav p-mt-3" }
const _hoisted_29 = { class: "free" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-lock" }, null, -1)
const _hoisted_31 = { class: "sidebar" }
const _hoisted_32 = { class: "content" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "mobile-hide sidebar-image" }, [
  /*#__PURE__*/_createElementVNode("img", { src: "/kandidaten/img/Step 0.png" })
], -1)
const _hoisted_34 = { class: "mobile-hide headline" }

import { computed, getCurrentInstance, ref } from "vue";
    import { useI18n } from "vue-i18n";
    import { createAuthenticationService } from '../../services/authenticationService';
    import { useRoute } from "vue-router";
    import { BrandId } from "@/models/BrandIds";
    import validator from "validator";
    import Header from "@/components/Header.vue";

    
export default /*#__PURE__*/_defineComponent({
  __name: 'Registration',
  emits: ['closed', 'registered', 'login'],
  setup(__props, { expose: __expose, emit: __emit }) {

    const emit = __emit;
    const { t } = useI18n();

    const app = getCurrentInstance();
    const display = ref(false);
    const route = useRoute();
    const user = ref();
    const password = ref();
    const password2 = ref();
    const showLoginInsteadOfContinue = ref(false);
    const close = function () {
        display.value = false;
        emit("closed");
    }

    const show = function (email) {
        user.value = email;
        showSpinner.value = false;
        error.value = undefined;
        display.value = true;
    }
    const submit = ref(false);
    const error = ref();
    const showSpinner = ref(false);
    const acceptTermsAndConditions = ref(false);

    const authenticationService = createAuthenticationService(app);

    const checkMail = async () => {

        if (!user.value) {
            showLoginInsteadOfContinue.value = false;
            return;
        }

        if (!validator.isEmail(user.value)) {
            showLoginInsteadOfContinue.value = false;
            return;
        }
        showLoginInsteadOfContinue.value = await authenticationService.emailAlreadyExists(user.value);
    }

    const validEmail = computed(() => {
        if (!user.value) return false;
        let isValidEmail = validator.isEmail(user.value);
        if (isValidEmail) {
            for (var i = 0; i < window.invalidDomains.length; i++) {
                if (user.value.toLowerCase().includes(window.invalidDomains[i].toLowerCase())) {
                    return false;
                }
            }
            return true;
        } else {
            return isValidEmail;
        }
    });

    const login = () => {
        emit("login", null, { email: user.value });
        display.value = false;
    }

    const signup = async () => {

        submit.value = true;

        if (!password.value || password.value.length < 8 || !validEmail.value)
            return;

        if (password2.value != password.value)
            return;

        if (!acceptTermsAndConditions.value)
            return;

        showSpinner.value = true;
        error.value = undefined;

        const singUpSuccess = await authenticationService.signUpWithPassword({
            brandId: BrandId.BigFour,
            emailAddress: user.value,
            password: password.value,
            encryptedCandidateId: null,
            source: route.query.source ? route.query.source?.toString() : "organic"
        });

        if (singUpSuccess) {
            emit("registered");
            close();
        } else {
            if (singUpSuccess == false) {
                error.value = t("registration.error2");
            }
            if (singUpSuccess == null) {
                error.value = t("registration.error3");
            }
        }
        showSpinner.value = false;
    }

    __expose({
        show,
        close,
    });


return (_ctx: any,_cache: any) => {
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Divider = _resolveComponent("Divider")!
  const _component_Password = _resolveComponent("Password")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: display.value,
    "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((display).value = $event)),
    modal: true,
    class: "reg-dialog finance",
    baseZIndex: 104,
    closable: false
  }, {
    header: _withCtx(() => [
      _createVNode(Header)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (!showSpinner.value)
              ? (_openBlock(), _createElementBlock("img", _hoisted_4))
              : _createCommentVNode("", true),
            (!showSpinner.value)
              ? (_openBlock(), _createElementBlock("img", _hoisted_5))
              : _createCommentVNode("", true),
            (showSpinner.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createVNode(_component_ProgressSpinner)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("h1", null, _toDisplayString(_unref(t)("registration.headline2")) + " " + _toDisplayString(_unref(t)("registration.headline3")), 1),
                  _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(t)("registration.headline4")), 1),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", null, [
                      _createElementVNode("span", _hoisted_10, [
                        _createVNode(_component_InputText, {
                          id: "username",
                          type: "username",
                          modelValue: user.value,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((user).value = $event)),
                          autofocus: "",
                          onkeypress: checkMail(),
                          "data-cy": "reg-usermail",
                          class: _normalizeClass({ 'p-invalid': showLoginInsteadOfContinue.value })
                        }, null, 8, ["modelValue", "onkeypress", "class"]),
                        _createElementVNode("label", _hoisted_11, _toDisplayString(_unref(t)("registration.label1")) + " *", 1)
                      ]),
                      (submit.value && !validEmail.value)
                        ? (_openBlock(), _createElementBlock("small", _hoisted_12, _toDisplayString(_unref(t)("registration.error1")), 1))
                        : _createCommentVNode("", true),
                      (showLoginInsteadOfContinue.value)
                        ? (_openBlock(), _createElementBlock("small", _hoisted_13, _toDisplayString(_unref(t)("registration.error3")), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("span", _hoisted_14, [
                        _createVNode(_component_Password, {
                          id: "new-password",
                          modelValue: password.value,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event)),
                          autocomplete: "one-time-code",
                          feedback: false,
                          toggleMask: "",
                          "data-cy": "reg-password"
                        }, {
                          header: _withCtx(() => [
                            _createElementVNode("h3", null, _toDisplayString(_unref(t)("registration.password.choose")), 1),
                            _createElementVNode("h6", null, _toDisplayString(_unref(t)("registration.password.strength")), 1)
                          ]),
                          footer: _withCtx((sp) => [
                            _createTextVNode(_toDisplayString(sp.level) + " ", 1),
                            _createVNode(_component_Divider),
                            _createElementVNode("h6", null, _toDisplayString(_unref(t)("registration.password.hint")), 1),
                            _createElementVNode("ul", _hoisted_15, [
                              _createElementVNode("li", null, _toDisplayString(_unref(t)("registration.password.hint.signs")), 1)
                            ])
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createElementVNode("label", _hoisted_16, _toDisplayString(_unref(t)("password")) + " *", 1)
                      ]),
                      (submit.value && !password.value)
                        ? (_openBlock(), _createElementBlock("small", _hoisted_17, _toDisplayString(_unref(t)("registration.password.missing")), 1))
                        : _createCommentVNode("", true),
                      (password.value && password.value.length < 8)
                        ? (_openBlock(), _createElementBlock("small", _hoisted_18, [
                            _createTextVNode(_toDisplayString(_unref(t)("registration.password.safety")) + " ", 1),
                            _createElementVNode("span", null, _toDisplayString((8 - password.value.length)) + " " + _toDisplayString(_unref(t)('registration.password.charleft')), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("span", _hoisted_19, [
                        _createVNode(_component_Password, {
                          id: "new-password2",
                          modelValue: password2.value,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((password2).value = $event)),
                          feedback: false,
                          toggleMask: "",
                          autocomplete: "one-time-code",
                          "data-cy": "reg-password-repeat"
                        }, null, 8, ["modelValue"]),
                        _createElementVNode("label", _hoisted_20, _toDisplayString(_unref(t)("registration.password.repeat")) + " *", 1)
                      ]),
                      (submit.value && !password2.value)
                        ? (_openBlock(), _createElementBlock("small", _hoisted_21, _toDisplayString(_unref(t)("registration.password.missing")), 1))
                        : _createCommentVNode("", true),
                      (submit.value && password.value != password2.value && password.value && password2.value)
                        ? (_openBlock(), _createElementBlock("small", _hoisted_22, _toDisplayString(_unref(t)("registration.password.notthesame")), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("span", _hoisted_23, [
                        _createVNode(_component_Checkbox, {
                          id: "termsandconditions",
                          "data-cy": "termsAndConditionsCheckbox",
                          modelValue: acceptTermsAndConditions.value,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((acceptTermsAndConditions).value = $event)),
                          binary: true
                        }, null, 8, ["modelValue"]),
                        _createElementVNode("label", _hoisted_24, [
                          _createTextVNode(_toDisplayString(_unref(t)("registration.data.policy.label1")) + " ", 1),
                          _createElementVNode("a", _hoisted_25, _toDisplayString(_unref(t)("privacy.policy")), 1),
                          _createTextVNode(_toDisplayString(_unref(t)("registration.data.policy.label2")), 1)
                        ])
                      ]),
                      (submit.value && !acceptTermsAndConditions.value)
                        ? (_openBlock(), _createElementBlock("small", _hoisted_26, _toDisplayString(_unref(t)("registration.data.policy.please.accept")), 1))
                        : _createCommentVNode("", true)
                    ]),
                    (error.value)
                      ? (_openBlock(), _createElementBlock("b", _hoisted_27, _toDisplayString(error.value), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_28, [
                      (!showLoginInsteadOfContinue.value)
                        ? (_openBlock(), _createBlock(_component_Button, {
                            key: 0,
                            label: _unref(t)('registration.headline6'),
                            onClick: signup,
                            "data-cy": "button-profile-next",
                            class: "button-primary big stretch"
                          }, null, 8, ["label"]))
                        : (_openBlock(), _createBlock(_component_Button, {
                            key: 1,
                            label: _unref(t)('registration.button.continue.login'),
                            onClick: login,
                            "data-cy": "button-profile-next",
                            class: "button-primary big stretch"
                          }, null, 8, ["label"]))
                    ]),
                    _createElementVNode("div", _hoisted_29, [
                      _hoisted_30,
                      _createTextVNode(" " + _toDisplayString(_unref(t)("registration.headline5")), 1)
                    ])
                  ])
                ]))
          ]),
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              _hoisted_33,
              _createElementVNode("div", _hoisted_34, _toDisplayString(_unref(t)("registration.headline1")), 1)
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})